/*
 * @FilePath     : /fe-estrain-customer/src/config/interceptors/respones/index.js
 * @Author       : LiYang
 * @Date         : 2021-12-07 11:21:24
 * @LastEditTime : 2022-02-18 21:34:10
 * @LastEditors  : Please set LastEditors
 * @Description  : 
 */

import { serial } from '@didi/es-mpx-shared'
import { relog } from '@/config/usex'
import respones from './respones'

export default serial(relog, respones)